import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📚 Amigurumi Business Pack (12 Tomos)',
  price: '$19.990'
}, {
  label: '🎁 Calculadora de Costos ARS',
  price: 'GRATIS'
}, {
  label: '🎁 Foto-Studio con Celular',
  price: 'GRATIS'
}, {
  label: '🎁 30 Plantillas de Instagram',
  price: 'GRATIS'
}, {
  label: '🎁 Tu Tienda Online en 24 Horas',
  price: 'GRATIS'
}, {
  label: '🎁 Diccionario Maestro de Patrones',
  price: 'GRATIS'
}, {
  label: '🛡️ Garantía 7 días',
  price: 'INCLUIDA'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago · Tarjeta'
}];
export function ValueStack() {
  return <section id="value" aria-label="Resumen de la oferta" className="border-y border-white/5 bg-ink-2" data-id="element-186" data-mp="30wk0ezfwnl68">
      <div className="mx-auto max-w-2xl px-5 pb-6 pt-5 text-center" style={{
      paddingTop: "9px"
    }} data-id="element-187" data-mp="1tetrcgzp8hz1">
        <h2 className="pb-2 font-display text-2xl font-black text-white sm:text-4xl" data-id="element-188" data-mp="1ogs6bqipq8kx">
          🚀 Lanzá tu negocio de amigurumis hoy
        </h2>
        <p className="mt-1 text-sm text-white/60" style={{
        paddingTop: "28px",
        marginTop: "-28px",
        marginBottom: "-28px"
      }} data-id="element-189" data-mp="236halum3qspf">
          Un pago único. Acceso de por vida. Sistema listo para aplicar en minutos.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink text-left" data-id="element-190" data-mp="284j5rdwsyih9">
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-white/50" data-id="element-191" data-mp="2m3sa9gbnbo5e">
            <span data-id="element-192" data-mp="2h5gz929m77ll">Qué incluye</span>
            <span data-id="element-193" data-mp="rpzr0v3lskk7">Precio</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-white/5 px-5 py-3 text-sm" style={{
          paddingTop: "7px"
        }} data-id="element-194" data-mp="rqj6841vcuuj">
              <span className="text-white/80" data-id="element-195" data-mp="2mtxrya82iglz">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-white' : 'shrink-0 font-bold text-bordo-light'} data-id="element-196" data-mp="2mvilpxmk5vis">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-wrap items-center justify-between gap-2 bg-white/5 px-5 py-3" style={{
          paddingTop: "2px",
          paddingBottom: "4px"
        }} data-id="element-197" data-mp="2vw70iujrzzwq">
            <span className="text-sm font-bold text-white" data-id="element-198" data-mp="35rifndz3j950">
              Valor total real: <span className="text-white/40 line-through" data-id="element-199" data-mp="3aq364lojqeg9">$70.990</span>
            </span>
            <span className="font-display text-2xl font-black text-silver-shine" data-id="element-200" data-mp="3fhl89d2b2l2t">$19.990 ARS</span>
          </div>
        </div>

        <div className="mt-7" data-id="element-201" data-mp="3jix07p8njie6">
          <CTAButton data-id="element-202" data-mp="3jl9e9rbah8ly">Sí, quiero emprender con mis amigurumis — $19.990 ARS</CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-203" data-mp="3ogoqyfxk8ygs">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-204" data-mp="7hgirsbowmiv">
              <Icon className="h-4 w-4 text-plata" aria-hidden="true" data-id="element-205" data-mp="2gaohq2dsr78" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}